$(document).foundation();

console.log('testds');